import {
  COOKIE_OPTIONS,
  SELF_SERVICE_NEW_PAGE_VARIANT,
  SELF_SERVICE_OLD_PAGE_VARIANT,
  type SELF_SERVICE_VARIANTS
} from '@/utils/constants/cookies'

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  if (!runtimeConfig.public.selfServiceCookieName) {
    return
  }

  const selfServiceVariant = useCookie<SELF_SERVICE_VARIANTS>(runtimeConfig.public.selfServiceCookieName, {
    ...COOKIE_OPTIONS,
    maxAge: 60 * 60 * 24 * 30 // 30 days
  })

  if (selfServiceVariant.value) {
    return
  }

  selfServiceVariant.value =
    Math.random() < runtimeConfig.public.selfServiceCookieSplit
      ? SELF_SERVICE_NEW_PAGE_VARIANT
      : SELF_SERVICE_OLD_PAGE_VARIANT
})
